import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './preStartUp/index';
import './i18n';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

ReactDOM.render(
  <ErrorBoundary>
    <BrowserRouter basename="">
      <App />
    </BrowserRouter>
  </ErrorBoundary>,
  document.getElementById('root')
);
